/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetTipsRequest, TGetTipsModel, IMappers, TGetTipsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetTipsResponseV4 } from '../../entities/tips/GetTipsResponseV4';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetTipsModel(parameters: TGetTipsRequest): TGetTipsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'text-search',
    pathApi: '/v4/get-tips/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetTipsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetTipsRequest;
}

export async function fetchGetTips<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetTipsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetTipsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetTipsModel(parameters),
    config,
  )) as FetchResponse<TGetTipsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetTipsResponseV4, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetTipsResponse>;
}
